// angular
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { CoreService } from '../../../core/core.service';
import { AppService } from '../../../app.service';
import { KlenicoMeService } from '../../me.service';
import { TranslateService } from '@ngx-translate/core';


@Component({
    selector: 'me-imprint',
    templateUrl: './imprint.component.html',
    styleUrls: ['./imprint.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class MeImprintComponent implements OnInit {
    data: any;
    url = 'lp/imprint';

    constructor(
        public appService: AppService,
        public coreService: CoreService,
        public meService: KlenicoMeService,
        public translate: TranslateService
    ) {
       
    }

    ngOnInit() {
        this.meService.isLandingPage = true;
        this.getImprint();

        this.translate.onLangChange.subscribe(res => {
            this.getImprint();
        })
    }

    getImprint() {
        this.appService.getStoryBlokDataForClinic(this.url).subscribe(res => {
            let contents = res['story']['content'] ?? [];
            this.data = contents;
            this.appService.isLoading = false;
        });
    }

    scrollToElement(element): void {
        (document.getElementById(element) as HTMLElement).scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
    }

    toTop() {
        (document.getElementById('imprint-page') as HTMLElement).scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
    }
}
